<template>
  <div>
    <div class="timebox">
      {{ data.meetingStateTime }}-{{ getDateTime(data.meetingEndTime) }}
    </div>
    <div class="middle">
      <List border size="small" style="width: 80%">
        <ListItem>
          <p class="leftTitle">发起人:</p>
          <p class="rightTitle">{{ data.principalName }}</p>
        </ListItem>
        <ListItem class="title">
          <p class="leftTitle">会议主题:</p>
          <p class="rightTitle">{{ data.meetingtTitle }}</p>
        </ListItem>
        <ListItem>
          <p class="leftTitle">会议地点:</p>
          <p class="rightTitle">{{ data.meetingLocationName }}</p>
        </ListItem>
        <ListItem>
          <p class="leftTitle">签到时间:</p>
          <p class="rightTitle">{{ data.meetingSignState }}</p>
        </ListItem>
        <ListItem>
          <p class="leftTitle">邀请人员:</p>
          <p class="rightTitle">{{ name }}</p>
        </ListItem>
        <ListItem>
          <p class="leftTitle">共需签到(⼈)</p>
          <p class="rightTitle">
            {{ data.sysUserList ? data.sysUserList.length : null }}
          </p>
        </ListItem>
        <ListItem>
          <p class="leftTitle">已签到</p>
          <p class="rightTitle">{{ yi }} {{ SignName }}</p>
        </ListItem>
        <ListItem v-show="chi ? true : false">
          <p class="leftTitle">迟到</p>
          <p class="rightTitle">{{ chi }} {{ SignName2 }}</p>
        </ListItem>
        <ListItem v-show="wei ? true : false">
          <p class="leftTitle">未签到</p>
          <p class="rightTitle">{{ wei }}</p>
        </ListItem>
      </List>
      <div class="right">
        <p v-for="item in SignNameList" :key="item" class="rightname">
          {{ item }}
        </p>
      </div>
    </div>
    <div class="container">
      <div class="section1">
        <p>{{ text }}</p>
      </div>
      <div class="section2" v-show="!block ? false : true">
        <div style="margin-left: 15px">
          <el-image
            class="image"
            :src="url"
            :preview-src-list="srcList"
            :key="isKey"
            ref="imgUp"
          ></el-image>
        </div>
        <p>{{ data.meetingSignState }} -{{ getDateTime(data.meetingEndTime) }}</p>
      </div>
      <div class="section3" v-show="!block ? false : true">
        <el-button @click="qrcodeurl" icon="el-icon-refresh" circle></el-button>
        <el-button @click="tominute" type="primary">填写会议记录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { IMAGE_HOST } from "@/../config";

export default {
  data() {
    return {
      url: "",
      srcList: [],
      id: "",
      data: {},
      text: "",
      name: "",
      time: dayjs().format("YYYY-MM-DD HH:mm"),
      isKey: 0,
      isKeyA: 1,
      timer: null,
      block: true,
      isKeyT: true,
      SignName: "",
      SignName2: "",
      SignNameList: [],
      yi: "",
      chi: "",
      wei: "",
    };
  },
  props: ["id"],
  mounted() {
    if (this.id) {
      this.initData();
      this.qrcodeurl();
    }
  },
  created() {
    this.timer = setInterval(() => {
      this.qrcodeurl();
      this.initData();
    }, 5000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async qrcodeurl() {
      // 加载详情数据
      let id = this.id;
      $utils.api.load(`/admin/system/meeting/qrcode/${id}`, {}).then((res) => {
        if (res && res.code == 200) {
          this.isKeyA = this.isKeyA + 1;
          let url = res.msg + `?v=${this.isKeyA}`;
          this.url = url ? (url.includes("http") ? url : IMAGE_HOST + url) : url;
          this.isKey = Date.now();
          this.$refs.imgUp.$el.src = this.url;
          this.srcList = [];
          this.srcList.push(this.url);
        }
      });
    },
    getDateTime(val) {
      let time = val ? val.substring(10) : null;
      return time;
    },
    async initData() {
      // 加载详情数据
      let id = this.id;
      $utils.api.load(`/admin/system/meeting/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.data = res.data;
          let type = res.data.type;
          if (type == 1) {
            this.block = false;
            this.text = "签到暂未开始，请稍等";
          } else if (type == 2) {
            this.block = true;
            this.text = "会议签到中";
          } else if (type == 3) {
            this.block = true;
            this.text = "会议进行中,可继续签到";
          } else if (type == 4) {
            this.block = true;
            this.text = "会议已结束,请扫码签退";
          } else {
            this.block = true;
            this.text = "签到时间已过，签到视为迟到";
          }
          let names = "";
          let arr = res.data.meetingSignResponseList;
          this.SignName = "";
          this.SignName2 = "";
          this.SignNameList = [];
          if (arr) {
            let count = { num1: 0, num2: 0, num3: 0 };
            arr.forEach((item) => {
              if (item.state === 1 || item.state === 2) {
                count.num1++;
              }
              if (item.state === 2) {
                count.num2++;
              }
              if (item.state === 3) {
                count.num3++;
              }
            });
            this.yi = count.num1;
            this.chi = count.num2;
            this.wei = count.num3;
            arr.forEach((item) => {
              let state = item.state;
              let nickName = item.sysUser.nickName;
              let name = nickName;
              names += name + ",";
              if (state == 1 || state == 2) {
                let text = "签到成功";
                this.SignNameList.push(name + text);
              }
              if (state == 1 || state == 2) {
                this.SignName += name + ",";
              }
              if (state == 2) {
                this.SignName2 += name + ",";
              }
            });
          }
          this.name = names.substring(0, names.length - 1);
        }
      });
    },
    tominute() {
      this.$Modal.remove();
      setTimeout(() => {
        $utils.url.push({ name: "minute", query: { id: this.id } });
      }, 200);
    },
  },
};
</script>

<style scoped>
.leftTitle {
  width: 11%;
}
.rightTitle {
  width: 89%;
}
.image {
  width: 200px;
  height: 200px;
  border: 7px solid #47a85f;
  border-radius: 5px;
}
.title {
  font-size: 18px;
  font-weight: 700;
}
.right {
  height: 390px;
  width: 20%;
  border: 1px solid #e8eaec;
  border-radius: 6px;
  overflow-y: auto;
}
.rightname {
  margin: 10px 0 10px 10px;
  font-size: 26px;
  font-weight: 600;
}
.timebox {
  width: 99%;
  background-color: #409eff;
  text-align: center;
  color: white;
  font-size: 1.625rem;
  margin: 5px auto;
  padding: 3px 0;
  border-radius: 10px;
}
.middle {
  /* height: 310px; */
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.middleR,
.middleL {
  font-size: 20px;
}
.middleR {
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.blue {
  font-size: 26px;
  color: blue;
}
.green {
  font-size: 26px;
  color: green;
}
.red {
  font-size: 26px;
  color: red;
}
.orange {
  font-size: 26px;
  color: rgb(255, 157, 0);
}
.container {
  margin: 5px auto;
  font-size: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 3px 10px;
  align-items: flex-end;
}
.section1 {
  color: green;
}
.border_css {
  border-radius: 1px;
}
</style>
